module.exports = __webpack_public_path__ + "img/sentiment-trello.843fdd96.png";